<template>
  <!-- 待开始 -->
  <img v-if="activityStatus === '0'" src="@/assets/img/hdbmz.png" />
  <!-- 进行中 -->
  <img v-else-if="activityStatus === '1'" src="@/assets/img/hdjxz.png" />
  <!-- 已结束 -->
  <img v-else src="@/assets/img/tag1.png" />
</template>

<script>
export default {
  props: {
    activityStatus: {
      type: String,
      default: "2",
    },
  },
  name: "VActivityStatus",
};
</script>

<style scoped></style>
